<template>
  <el-dialog
    :visible.sync="show_store_details_save_confirmation"
    :lock-scroll="true"
		:show-close="true"
    :custom-class="'store-details-save-confirm-popup'"
  >
    <div class="confirmation-header">
      <h2>Save Store Details</h2>
      <span class="close-icon" @click="toggleStoreDetailsSavePopup">
        <i class="el-icon-circle-close"></i>
      </span>
    </div>

    <div class="confirmation-body">
      <div class="confirmation-item mb-3">
        <el-radio v-model="store_details_save_choice" label="2">Save without updating labour hours</el-radio>
      </div>
      <div class="confirmation-item">
        <el-radio v-model="store_details_save_choice" class="mb-4" label="1">Update Labour Hours</el-radio>
        <p class="description-text">This will update labour projections from tomorrow till next week Sunday as per the revised store settings. Also, ensure you have setup fixed hours / non-coverage hours as per updated time.</p>
      </div>
    </div>

    <div class="confirmation-footer">
      <el-button
        type="warning"
        plain
        class="primary-settings-button__save"
        size="small"
        @click="saveStoreDetailsData"
      >Confirm</el-button>
    </div>
  </el-dialog>
</template>

<script>
import settingsMixin from '../../../../../../mixins/settingsMixin';
export default {
  name: "StoreDetailsSaveConfirmation",
  mixins: [settingsMixin]
}
</script>

<style lang="scss">
  .confirmation-header {
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
    justify-content: space-between;
  }
  .close-icon {
    cursor: pointer;
    font-size: 28px;
    color: #333;
  }
  .confirmation-body {
    padding: 15px;
  }
  .confirmation-footer {
    text-align: right;
  }
  .store-details-save-confirm-popup {
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #f9a168;
      background: #f9a168;
    }
    .el-radio__label {
      font-weight: 700;
      color: #333;
    }
    .el-radio__input.is-checked+.el-radio__label {
      color: #333;
    }
    .description-text {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 19px;
      color: #999999;
      margin-top: 8px;
      margin-bottom: 16px;
    }
  }

  .store-details-save-confirm-popup .el-dialog__header{
    display: none;
  }
</style>